export const GET_EVENT_DETAIL_DATA = 'GET_EVENT_DETAIL_DATA';
export const GET_EVENT_DETAIL_LOADING = 'GET_EVENT_DETAIL_LOADING';
export const GET_EVENT_DETAIL_ERROR = 'GET_EVENT_DETAIL_ERROR';
export const GET_TICKET_DATA = 'GET_TICKET_DATA';
export const GET_TICKET_LOADING = 'GET_TICKET_LOADING';
export const GET_EVENT_CATEGORIES_DATA = 'GET_EVENT_CATEGORIES_DATA';
export const GET_EVENT_CATEGORIES_LOADING = 'GET_EVENT_CATEGORIES_LOADING';
export const GET_EVENT_TYPES_DATA = 'GET_EVENT_TYPES_DATA';
export const GET_EVENT_TYPES_LOADING = 'GET_EVENT_TYPES_LOADING';
export const GET_EVENTS_LIST_DATA = 'GET_EVENTS_LIST_DATA';
export const GET_EVENTS_LIST_LOADING = 'GET_EVENTS_LIST_LOADING';
